import { createContext } from 'react';

export interface BookingContextType {
  openModal: (advisorId: number) => void;
  closeModal: () => void;
}

const BookingContext = createContext<BookingContextType>({
  openModal: () => {},
  closeModal: () => {},
});

export default BookingContext;
